import moment from 'moment-timezone'
import { CalendarIcon } from '@calendly/ui/components/icons'
import { DetailsItem as Item } from '@calendly/booking-kit'
import { useDeviceType } from '@calendly/ui/hooks/use-device-type'
import styled from 'astroturf/react'

import { formatEventTimeToDisplay, formatDate } from 'services/spot_time'
import { useI18n } from 'locales'
import _DateTimeWrapper from "event_time-DateTimeWrapper.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/cancellation/cancellation_components/details/event_time.js?styleId=DateTimeWrapper";
import _TimeWrapper from "event_time-TimeWrapper.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/cancellation/cancellation_components/details/event_time.js?styleId=TimeWrapper";
import _IconWrapper from "event_time-IconWrapper.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/cancellation/cancellation_components/details/event_time.js?styleId=IconWrapper";


const DateTimeWrapper = /*#__PURE__*/styled('div', null, {
  displayName: "DateTimeWrapper",
  styles: _DateTimeWrapper
})
const TimeWrapper = /*#__PURE__*/styled('div', null, {
  displayName: "TimeWrapper",
  styles: _TimeWrapper
})
const IconWrapper = /*#__PURE__*/styled('div', null, {
  displayName: "IconWrapper",
  styles: _IconWrapper
})

const getEventTime = (startTime, endTime, timezone, timeNotation) => {
  const timeToDisplay = formatEventTimeToDisplay({
    start_time: moment.tz(startTime, timezone),
    end_time: moment.tz(endTime, timezone)
  }, timeNotation)
  return `${timeToDisplay}, `
}

const getEventDate = (startTime, timezone, i18n) => {
  const timeMoment = moment.tz(startTime, timezone)
  return formatDate(timeMoment, i18n.t('time.formats.date_full'), i18n.locale)
}


const EventTime = ({ timeNotation, timezone, source: { start_time: startTime, end_time: endTime } }) => {
  const { i18n } = useI18n()
  const isPhone = useDeviceType('isPhone')
  const eventTime = getEventTime(startTime, endTime, timezone, timeNotation)
  const eventDate = getEventDate(startTime, timezone, i18n)
  const eventDateAndTime = eventTime + eventDate
  return (
    <Item>
      <IconWrapper>
        <CalendarIcon size="large" spacingRight={8} data-id="details-item-icon" />
      </IconWrapper>
      {isPhone
        ? (
          <DateTimeWrapper>
            <TimeWrapper>
              {' '}
              {eventTime}
            </TimeWrapper>
            <div>
              {' '}
              {eventDate}
            </div>
          </DateTimeWrapper>
        ) : (
          <div>
            {' '}
            {eventDateAndTime}
          </div>
        )}
    </Item>
  )
}

export default EventTime
